import React from "react";
import { View, Text } from "@react-pdf/renderer";
import Styles from "../Styles";
import { LabelLineRow } from "./FormFields";

const PolicyFieldRow = ({ styles, label, lines = 1 }) => (
  <View
    style={{
      width: "100%",
      flexDirection: "row",
      alignItems: "flex-start",
      marginBottom: lines > 1 ? 4 : 5,
    }}
  >
    <Text
      style={{
        ...styles.ButtonTextSmall,
        // fontSize: 9,
        width: 82,
        flexShrink: 0,
        marginRight: 6,
      }}
      wrap={false}
    >
      {label}
    </Text>

    <View style={{ flex: 1 }}>
      {Array.from({ length: lines }).map((_, index) => (
        <View
          key={index}
          style={{
            ...styles.line,
            flexGrow: 0,
            height: 16,
            marginTop: index === 0 ? 0 : 5,
          }}
        />
      ))}
    </View>
  </View>
);

const PolicyColumn = ({ styles }) => (
  <View style={{ width: "48%" }}>
    <PolicyFieldRow styles={styles} label="Company" />
    <PolicyFieldRow styles={styles} label="Plan No." />
    <PolicyFieldRow styles={styles} label="On Whose Life" />
    <PolicyFieldRow styles={styles} label="Sum Assured" />
    <PolicyFieldRow styles={styles} label="Contact" />
    <LabelLineRow styles={styles} label="Reason for Purchase" lines={0} />
    <LabelLineRow styles={styles} label="" lines={2} />
  </View>
);

const LifeAssurancePoliciesAndPensionPlans = ({ primaryColor = "081e56" }) => {
  const styles = Styles(primaryColor);

  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
      <Text style={styles.ContentSemiBold}>
        Life Assurance Policies and Pension Plans
      </Text>

      <View style={{ ...styles.panel }}>
        <View style={{ width: "100%" }}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              marginBottom: 8,
              gap: 24,
            }}
          >
            <PolicyColumn styles={styles} />
            <PolicyColumn styles={styles} />
          </View>

          <View
            style={{
              height: 10,
            }}
          />
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              gap: 24,
            }}
          >
            <PolicyColumn styles={styles} />
            <PolicyColumn styles={styles} />
          </View>
          <View
            style={{
              height: 10,
            }}
          />
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              gap: 24,
            }}
          >
            <PolicyColumn styles={styles} />
            <PolicyColumn styles={styles} />
          </View>
        </View>
      </View>
    </View>
  );
};

export default LifeAssurancePoliciesAndPensionPlans;
